const SITE_URL = "https://premierelens.com";

export function buildMostRecommendedSeoMeta(_payload = {}) {
  return {
    title: "Most Recommended TV Shows and What to Watch Next | PremiereLens",
    description: "Start with a TV show you love and find what to watch next, or browse the shows that PremiereLens recommendations point to most often.",
    pathname: "/most-recommended",
    canonicalUrl: `${SITE_URL}/most-recommended`,
    ogUrl: `${SITE_URL}/most-recommended`,
    image: `${SITE_URL}/og-image.jpg`,
    robots: "index,follow",
    ogType: "website",
  };
}
